const tesst = document.getElementById('tesst');

if (tesst) {
  console.log('Hello');
}
